export default "\r\n<app-drug-list></app-drug-list>\r\n\r\n\r\n";